
import { ReactNode, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import Sidebar from './Sidebar';
import Header from './Header';
import MobileNav from './MobileNav';
import { OnboardingModal } from '@/components/common/OnboardingModal';
import { useOnboardingContext } from '@/context/OnboardingContext';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const { isOpen, handleClose } = useOnboardingContext();
  
  console.log('[Layout] Mounted at route:', location.pathname);
  
  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden">
      {/* Desktop Sidebar - показывается только на ≥1280px */}
      <div className="hidden desktop:block">
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      </div>
      
      {/* Mobile Navigation - hidden on desktop */}
      <MobileNav />
      
      {/* Main Content Area */}
      <div className={cn(
        "flex flex-col flex-1 transition-all duration-300 min-w-0 overflow-hidden",
        // Desktop margin adjustments (≥1280px)
        "desktop:ml-0",
        sidebarCollapsed ? "desktop:ml-16" : "desktop:ml-56"
      )}>
        <Header />
        <main className="flex-1 overflow-y-auto overflow-x-hidden w-full">
          <div className="w-full p-4 sm:p-6 space-y-6 max-w-7xl mx-auto">
            {children}
          </div>
        </main>
      </div>

      {/* Onboarding Modal */}
      <OnboardingModal open={isOpen} onClose={handleClose} />
    </div>
  );
};

export default Layout;
